import styled from 'styled-components';

const Logo = () => {
  return (
    <Container>
      <img id='logo' src='/logo1.png' />
    </Container>
  );
};
const Container = styled.div`
  width: 100%;
  padding: 16px;
  img {
    width: 100%;
  }
`;
export default Logo;
